function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), React.createElement("g", {
  fill: "none"
}, React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "12",
  fill: "#87BBFD"
}), React.createElement("path", {
  fill: "#6772E5",
  d: "M2.53 19.37A12 12 0 0023.8 9.84l-7.68 7.3a1.5 1.5 0 01-1.88.14l-4.5-3.1a1.5 1.5 0 00-1.88.13l-5.34 5.06z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M.97 12a11.02 11.02 0 0119.66-6.86l-4.5 4.27a1.5 1.5 0 01-1.88.15l-4.5-3.11a1.5 1.5 0 00-1.88.14l-6.84 6.48c-.04-.35-.06-.7-.06-1.07z"
}))));